module.exports = __webpack_public_path__ + "img/aej1n-66wvl.028.81944be3.png";